<template>
  <div id="register" class="newEnLogin flex">
    <!-- 新版 -->
        <div class="newEnLogin-left">
            <img src="../../../assets/images/newlogin1.png" alt="">
        </div>
        <div class="newEnLogin-right flex  align-cen">
          <div class="newEnLogin-right-form">
            <img src="../../../assets/images/newLogintit.png" alt="">
            <div class="form-cen">
                     <div class="newEnLogin-right-form-swich flex align-cen">
                    <div class="con" @click="openogin">密码登录</div>
                    <div class="con conactive">{{ $route.query.type == 1 ? "账号注册" : "找回密码" }}</div>
                </div>
                 <div class="newEnLogin-right-form-line"></div>
                 <div class="goReg" v-if="$route.query.type == 1">
            已有账号？<span
              style="color: #285b9c; cursor: pointer"
              @click="openogin"
              >直接登录</span
            >
          </div>
             <div class="enform-ipt">
                      <el-form
              label-position="right"
              label-width="0px"
              :model="formLabelAlign"
              ref="form1"
              :rules="rules"
            >
              <el-form-item prop="username">
                <el-input
                  placeholder="请输入手机号码"
                  v-model="formLabelAlign.username"
                  clearable
                >
                  <template slot="prepend">+86</template>
                </el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input
                  placeholder="请输入验证码"
                  v-model="formLabelAlign.code"
                  clearable
                >
                  <template slot="append">
                    <span
                      :class="
                        formLabelAlign.username && isSend
                          ? 'sendcode1'
                          : 'sendcode'
                      "
                      @click="
                        formLabelAlign.username && isSend ? sendcode() : ''
                      "
                    >
                      {{ sendmsg }}
                    </span>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  placeholder="请输入密码"
                  v-model="formLabelAlign.password"
                  show-password
                  clearable
                ></el-input>
              </el-form-item>
            </el-form>
             </div>
                <div class="enform-ys" v-if="$route.query.type == 1">
            <el-checkbox v-model="checked">
              我已阅读并同意
              <span @click="openAgreement(1)">《和隆优化服务条款》</span>
              <span @click="openAgreement(2)">《隐私条款》</span>
            </el-checkbox>
          </div>
            <div
            :class="checked ? 'enform-btn' : 'enform-btn1'"
            class="pubbtn"
            v-if="$route.query.type == 1"
            @click="submit(1, 'form1')"
          >
            立即注册
          </div>
          <div
            class="pubbtn enform-btn forgetBtn"
            v-else
            @click="submit(2, 'form1')"
          >
            确定修改
          </div>
            </div>
          </div>
              <div class="botinfo">
            <p>
                Copyright © 2023 北京和隆优化科技股份有限公司  
            </p>
            <p>
                京ICP备13020522号
            </p>
            <p>技术支持：北京和隆软件有限公司 </p>
         </div>
        </div>
    <!-- PC端 -->
    <!-- <div class="enCenForm">
      <img src="../../../assets/images/qy_tit.png" alt="" class="qy_tit" />
      <div class="enCenForm-form flex align-cen">
        <div class="left_bg">
          <img src="../../../assets/images/left_bg.png" alt="" class="" />
        </div>
        <div class="right-form">
          <div class="enform-tit">
            {{ $route.query.type == 1 ? "账号注册" : "找回密码" }}
          </div>
          <div class="goReg" v-if="$route.query.type == 1">
            已有账号？<span
              style="color: #285b9c; cursor: pointer"
              @click="openogin"
              >直接登录</span
            >
          </div>
          <div class="enform-ipt">
            <el-form
              label-position="right"
              label-width="0px"
              :model="formLabelAlign"
              ref="form1"
              :rules="rules"
            >
              <el-form-item prop="username">
                <el-input
                  placeholder="请输入手机号码"
                  v-model="formLabelAlign.username"
                  clearable
                >
                  <template slot="prepend">+86</template>
                </el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input
                  placeholder="请输入验证码"
                  v-model="formLabelAlign.code"
                  clearable
                >
                  <template slot="append">
                    <span
                      :class="
                        formLabelAlign.username && isSend
                          ? 'sendcode1'
                          : 'sendcode'
                      "
                      @click="
                        formLabelAlign.username && isSend ? sendcode() : ''
                      "
                    >
                      {{ sendmsg }}
                    </span>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  placeholder="请输入密码"
                  v-model="formLabelAlign.password"
                  show-password
                  clearable
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="enform-ys" v-if="$route.query.type == 1">
            <el-checkbox v-model="checked">
              我已阅读并同意
              <span @click="openAgreement(1)">《和隆优化服务条款》</span>
              <span @click="openAgreement(2)">《隐私条款》</span>
            </el-checkbox>
          </div>
          <div
            :class="checked ? 'enform-btn' : 'enform-btn1'"
            class="pubbtn"
            v-if="$route.query.type == 1"
            @click="submit(1, 'form1')"
          >
            立即注册
          </div>
          <div
            class="pubbtn enform-btn forgetBtn"
            v-else
            @click="submit(2, 'form1')"
          >
            确定修改
          </div>
        </div>
      </div>
    </div> -->
    <!-- 移动端 -->
    <!-- <div class="enform">
      <div class="enform-tit">
        {{ $route.query.type == 1 ? "账号注册" : "忘记密码" }}
      </div>
      <div class="enform-ipt">
        <el-form
          label-position="right"
          label-width="0px"
          :model="formLabelAlign"
          ref="form"
          :rules="rules"
        >
          <el-form-item prop="username">
            <el-input
              placeholder="请输入手机号码"
              v-model="formLabelAlign.username"
              clearable
            >
              <template slot="prepend">+86</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input
              placeholder="请输入验证码"
              v-model="formLabelAlign.code"
              clearable
            >
              <template slot="append">
                <span
                  :class="
                    formLabelAlign.username && isSend ? 'sendcode1' : 'sendcode'
                  "
                  @click="formLabelAlign.username && isSend ? sendcode() : ''"
                >
                  {{ sendmsg }}
                </span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              placeholder="请输入密码"
              v-model="formLabelAlign.password"
              show-password
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="enform-forget">
        已有账户？<span @click="openogin">直接登录</span>
      </div>
      <div class="enform-ys" v-if="$route.query.type == 1">
        <el-checkbox v-model="checked">
          我已阅读并同意
          <span @click="openAgreement(1)">《和隆优化服务条款》</span>
          <span @click="openAgreement(2)">《隐私条款》</span>
        </el-checkbox>
      </div>
      <div
        :class="checked ? 'enform-btn' : 'enform-btn1'"
        class="pubbtn"
        v-if="$route.query.type == 1"
        @click="submit(1, 'form')"
      >
        立即注册
      </div>
      <div
        class="pubbtn enform-btn forgetBtn"
        v-else
        @click="submit(2, 'form')"
      >
        立即重置
      </div>
    </div> -->
  </div>
</template>
<script>
import Format from "../../../utils/auth.js";
import { sendCode, register, login, resetPwd } from "@/api/auth/login"; // 发送验证码、注册、登录、重置密码
import LocaStorage from "../../../utils/localstorage.js";
import debounce from "../../../utils/debounce.js"; //防抖
const token1 = LocaStorage.setAge().get("token1");
export default {
  name: "register",
  data() {
    return {
      formLabelAlign: {
        username: "",
        code: "",
        password: "",
      },
      timeFun: "",
      checked: false,
      rules: {
        username: [
          {
            validator: Format.FormValidate.Form().Phone, //validator： 自定义验证规则
            trigger: "blur",
            message: "请正确输入手机号",
          },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      sendmsg: "发送",
      isSend: true,
    };
  },
  created() {
    this.$route.query.type == 1
      ? (document.title = "和隆优化-账号注册")
      : (document.title = "和隆优化-忘记密码");
  },
  methods: {
    // 打开隐私政策
    openAgreement(type) {
      const newurl = this.$router.resolve({
        name: "Agreement",
        query: { type: type },
      });
      window.open(newurl.href, "_blank");
    },
    // 跳转登录页
    openogin() {
      if (this.$route.query.appId) {
        this.$router.push({
          name: "enLogin",
          query: {
            id: this.$route.query.appId,
            redirectUrl: "endowloadDetail",
            type: 2,
          },
        });
      } else if (this.$route.query.solutionId) {
        this.$router.push({
          name: "enLogin",
          query: {
            id: this.$route.query.solutionId,
            redirectUrl: "enSolution",
            type: 2,
          },
        });
      } else if (this.$route.query.courseId) {
        this.$router.push({
          name: "enLogin",
          query: {
            id: this.$route.query.courseId,
            redirectUrl: "enCourseDetail",
          },
        });
      } 
      else if (this.$route.query.clueType) {
        this.$router.push({
          name: "enLogin",
          query: {
            clueType: this.$route.query.clueType,
            redirectUrl: this.$route.query.redirectUrl,
          },
        });
      } else if (this.$route.query.dataJson) {
        this.$router.push({
          name: "enLogin",
          query: {
            dataJson: this.$route.query.dataJson,
          },
        });
      } else {
        this.$router.push({
          name: "enLogin",
          query:this.$route.query.viewtype ? {redirectUrl: this.$route.query.redirectUrl || "homePage",type:this.$route.query.viewtype} : {redirectUrl: this.$route.query.redirectUrl || "homePage"}
        });
      }
    },
    // 注册提交
    submit(type, formName) {
      // type 1表示注册、2表示重置密码
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (type == 1) {
            let params = {
              loginName: that.formLabelAlign.username,
              verifyCode: that.formLabelAlign.code,
              password: that.formLabelAlign.password,
              appId: that.$route.query.appId,
               officialType:"1"
            };
            if (!this.checked)
              return this.$message.error("请勾选服务协议和隐私条款");
            //防抖提交
            debounce(() => {
              register(params, "enterprise")
                .then((res) => {
                  if (res.code == 0) {
                    this.$message({
                      message: "注册成功、正在进行跳转操作",
                      type: "success",
                    });
                    setTimeout(() => {
                      that.login();
                    }, 100);
                  } else {
                    this.$message.error(res.msg);
                  }
                })
                .catch((err) => {});
            }, 500);
          } else {
            let params = {
              loginName: that.formLabelAlign.username,
              verifyCode: that.formLabelAlign.code,
              password: that.formLabelAlign.password,
            };
            debounce(() => {
              resetPwd(params, "enterprise")
                .then((res) => {
                  if (res.code == 0) {
                    this.$message({
                      message: "密码重置成功、正在前往登录页...",
                      type: "success",
                    });
                    setTimeout(() => {
                      if (this.$route.query.appId) {
                        this.$router.push({
                          name: "enLogin",
                          query: {
                            appId: this.$route.query.appId,
                            redirectUrl: "endowloadDetail",
                            type: 2,
                          },
                        });
                      } else if (this.$route.query.solutionId) {
                        this.$router.push({
                          name: "enLogin",
                          query: {
                            solutionId: this.$route.query.solutionId,
                            redirectUrl: "enSolution",
                            type: 2,
                          },
                        });
                      } 
                      else if (this.$route.query.courseId) {
                            this.$router.push({
                              name: "enLogin",
                              query: {
                                id: this.$route.query.courseId,
                                redirectUrl: "enCourseDetail",
                              },
                            });
                          } 
                      else if (this.$route.query.clueType) {
                        this.$router.push({
                          name: "enLogin",
                          query: {
                            clueType: this.$route.query.clueType,
                            redirectUrl: this.$route.query.redirectUrl,
                          },
                        });
                      } else if (this.$route.query.dataJson) {
                        this.$router.push({
                          name: "enLogin",
                          query: {
                            dataJson: this.$route.query.dataJson,
                          },
                        });
                      } else {
                        this.$router.push({
                          name: "enLogin",
                          query:this.$route.query.viewtype ? {redirectUrl: this.$route.query.redirectUrl || "homePage",type:this.$route.query.viewtype} : {redirectUrl: this.$route.query.redirectUrl || "homePage"}
                        });
                      }
                    }, 100);
                  } else {
                    this.$message.error(res.msg);
                  }
                })
                .catch((err) => {});
            }, 500);
          }
        }
      });
    },
    login() {
      let params = {
        username: this.formLabelAlign.username,
        password: this.formLabelAlign.password,
        appId: this.$route.query.appId,
        solutionId: this.$route.query.solutionId,
        clueType: this.$route.query.clueType,
      };
      if (token1) {
        localStorage.removeItem("token1");
        localStorage.removeItem("userinfo1");
      }
      login(params, 2, "enterprise")
        .then((res) => {
          LocaStorage.setAge().set(
            "token1",
            res.token_type + " " + res.access_token
          );
          LocaStorage.setAge().set("userinfo1", res.user_info);
          if (this.$route.query.appId) {
            if (res.access_token) {
              this.$bus.$emit("tokenStatus", true);
              this.$router.replace({
                name: "endowloadDetail",
                query: {
                  id: this.$route.query.appId,
                  IsService:1,
                  type: 2,
                },
              });
            } else {
              setTimeout(() => {
                this.$router.replace({
                  name: "enLogin",
                  query: {
                    id: this.$route.query.appId,
                    redirectUrl: "endowloadDetail",
                    type: 2,
                  },
                });
              }, 100);
            }
          } else if (this.$route.query.solutionId) {
            if (res.access_token) {
              this.$bus.$emit("tokenStatus", true);
              this.$router.replace({
                name: "enSolution",
                query: {
                  id: this.$route.query.solutionId,
                  IsService:1,
                  type: 2,
                },
              });
            } else {
              setTimeout(() => {
                this.$router.replace({
                  name: "enLogin",
                  query: {
                    id: this.$route.query.appId,
                    redirectUrl: "enSolution",
                    type: 2,
                  },
                });
              }, 100);
            }
          }
           if (this.$route.query.courseId) {
            if (res.access_token) {
              this.$bus.$emit("tokenStatus", true);
              this.$router.replace({
                name: "enCourseDetail",
                query: {
                  id: this.$route.query.courseId,
                },
              });
            } else {
              setTimeout(() => {
                this.$router.replace({
                  name: "enLogin",
                  query: {
                    id: this.$route.query.courseId,
                    redirectUrl: "enCourseDetail",
                  },
                });
              }, 100);
            }
          }
           else if (this.$route.query.clueType) {
            if (res.access_token) {
              this.$bus.$emit("tokenStatus", true);
              this.$router.replace({
                name: this.$route.query.redirectUrl,
                query: {
                  IsService:1,
                },
              });
            } else {
              setTimeout(() => {
                this.$router.replace({
                  name: this.$route.query.redirectUrl,
                  query: {
                    clueType: this.$route.query.clueType,
                    redirectUrl: this.$route.query.redirectUrl,
                  },
                });
              }, 100);
            }
          } else if (this.$route.query.dataJson) {
            if (res.access_token) {
                this.$bus.$emit("tokenStatus", true);
              this.$router.replace({
                name: "inviteAccount",
                query: {
                  dataJson: this.$route.query.dataJson,
                },
              });
            }else{
                setTimeout(() => {
                this.$router.replace({
                  name: "enLogin",
                  query: {
                   dataJson: this.$route.query.dataJson,
                  },
                });
              }, 100);
            }
          } else {
            this.$router.push({
              name: this.$route.query.redirectUrl || "homePage",
              query: this.$route.query.viewtype ? {type:this.$route.query.viewtype} : {},
            });
          }
        })
        .catch((err) => {});
    },
    // 短信验证码
    sendcode() {
      let hasID = this.$route.query.type == 1 ? true : false;
      if (!this.formLabelAlign.username)
        return this.$message.error("请输入手机号");
      if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.formLabelAlign.username) == false)
        return;
      this.isSend = false;
      sendCode(
        {
          phone: this.formLabelAlign.username,
        },
        hasID
      )
        .then((res) => {
          if (res.code == 0) {
            let timer = 60;
            this.sendmsg = timer + "秒";
            this.timeFun = setInterval(() => {
              --timer;
              this.sendmsg = timer + "秒";
              if (timer < 10) this.sendmsg = "0" + timer + "秒";
              if (timer == 0) {
                this.isSend = true;
                this.sendmsg = "重新发送";
                clearInterval(this.timeFun);
              }
            }, 1000);
          } else {
            this.$message.error(res.msg);
            this.isSend = true;
          }
        })
        .catch((err) => {
          this.isSend = true;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.newEnLogin{
    width: 100%;
    height: 100vh; 
    overflow: hidden;
    position: relative;
    .newEnLogin-left{
        width: 70vw;
        height: inherit;
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .newEnLogin-right{
        width: 30vw;
        height: 100%;
        background: #fff;
        box-shadow: 0 4px 13px rgba(0, 0, 0, 0.2);
          position: relative;
        .newEnLogin-right-form{
            width: 70%;
            margin: 0 auto;
            img{
                width: 100%;
                max-height: 75px;
            }
            .form-cen{
                padding: 50px 0px;
                .newEnLogin-right-form-swich{
                    .con{
                        width: 50%;
                        text-align: center;
                        font-size: 18px;
                        cursor: pointer;
                    }
                    .conactive{
                       color: #3A7ACC;
                       position: relative;
                    }
                    .conactive::after{
                        content: '';
                        position: absolute;
                        width: 36px;
                        height: 3px;
                        background: #3A7ACC;
                        bottom: -12px;
                        left: 50%;
                        margin-left: -18px;
                    }
                }
                .newEnLogin-right-form-line{
                    width: 100%;
                    height: 1px;
                    background: #CCCCCC;
                    margin-top: 10px;
                }
                 .goReg{
                         font-size: 14px;
                        color: #767676;
                        margin-bottom: 10px;
                        padding-top: 20px;
                    }
                          .enform-ipt{
                        margin-top: 10px;
                        padding-bottom: 0px;
                    }
                   .enform-forget{
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #2C71C8;
                    line-height: 18px;
                    text-align: right;
                    cursor: pointer;
                }
                  .enform-ys {
              text-align: center;
              font-size: 12px;
            }
              .pubbtn {
      padding: 1vh 10px;
      width: 100%;
      margin: 0 auto;
      text-align: center;
      margin-top: 2vh;
      border-radius: 3px;
    }
      .enform-btn1 {
      background: #ddd;
      color: #f5f5f5;
      cursor: not-allowed;
    }
                   .enform-btn{
                   background: #2C71C8;
                   border-radius: 2px;
                   width: 100%;
                   text-align: center;
                   color: #fff;
                   font-size: 16px;
                   cursor: pointer;
                   outline: none;
                   border: none;
                }
            }
        }
        .botinfo{
            position: absolute;
            font-size: 12px;
            width: 100%;
            text-align: center;
            color:#808080 ;
            bottom: 0;
          p{
              padding-bottom: 0px;
          }
        }
    }
}
.loginbig {
  width: 100%;
  height: 100vh;
  background: url("~@/assets/images/qy_bg1.png") no-repeat 0 0;
  background-size: cover;
  overflow: hidden;
  position: relative;
  .enCenForm {
    width: 45vw;
    margin: 0 auto;
    height: 50vh;
    margin-top: 22vh;
    .qy_tit {
      height: 6vh;
      width: 100%;
    }
    .enCenForm-form {
      height: 44vh;
      background: #fff;
      margin-top: 3vh;
      border-radius: 5px;
      box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.2);
      position: relative;
      .left_bg {
        width: 50%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .right-form {
        width: 50%;
        .enform-tit {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 500;
          color: #333333;
          line-height: 38px;
          padding-bottom: 10px;
        }
        .goReg {
          font-size: 14px;
          color: #767676;
          margin-bottom: 10px;
        }
        .pubbtn {
          padding: 10px 10px;
          width: 85%;
          text-align: center;
          margin-top: 10px;
          border-radius: 3px;
        }
        .enform-btn {
          background: #2c71c8;
          color: #fff;
          cursor: pointer;
        }
        .enform-btn1 {
          background: #ddd;
          color: #f5f5f5;
          cursor: not-allowed;
        }
        .forgetBtn {
          margin-top: 4vh;
        }
      }
    }
  }
  .enform {
    display: none;
    width: 394px;
    height: 468px;
    background: url("~@/assets/images/enbg1.png") no-repeat 0 0;
    background-size: 100% 100%;
    position: absolute;
    top: 50%;
    margin-top: -234px;
    right: 18%;
    .enform-tit {
      padding: 30px 40px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 300;
      color: #4b4b4b;
      line-height: 38px;
    }
    .enform-ipt {
      padding: 0px 40px;
      margin-top: 0px;
      padding-bottom: 0px;
    }
    .enform-forget {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 18px;
      text-align: right;
      padding-right: 40px;
      span {
        color: #4a93f6;
        cursor: pointer;
      }
    }
    .enform-ys {
      text-align: center;
      padding-top: 20px;
      font-size: 13px;
    }
    .pubbtn {
      padding: 1vh 10px;
      width: 50%;
      margin: 0 auto;
      text-align: center;
      margin-top: 2vh;
      border-radius: 3px;
    }
    .enform-btn {
      background: #4a93f6;
      color: #fff;
      cursor: pointer;
    }
    .enform-btn1 {
      background: #ddd;
      color: #f5f5f5;
      cursor: not-allowed;
    }
    .forgetBtn {
      margin-top: 60px;
    }
  }
}
::v-deep {
  .el-form-item{
    margin-bottom: 15px !important;
  }
    .el-input:first-child{
        margin-top: 0;
    }
    .el-input{
        margin-bottom: 10px;
       input{
         color: #285B9C !important;
       }
    }
  .enform {
    .el-input__inner {
      border: none;
      border-bottom: 1px solid #bcbcbc;
      border-radius: 0;
    }
    .el-input {
      margin-top: 40px;
    }
    .el-input-group__append,
    .el-input-group__prepend {
      background-color: transparent;
      border: none;
      border-bottom: 1px solid #bcbcbc;
      border-radius: 0;
    }
    .el-input-group__prepend {
      padding: 0 5px;
    }
    .el-input-group__append {
      .sendcode {
        cursor: not-allowed;
        border-left: 1px solid #999;
        color: #999;
        padding-left: 20px;
      }
      .sendcode1 {
        cursor: pointer;
        border-left: 1px solid #999;
        color: #4a93f6;
        padding-left: 20px;
      }
    }
  }
  .enCenForm {
    .el-form {
      width: 105%;
    }
    .el-form-item {
      margin-bottom: 3vh;
      height: 3vh;
    }
    .el-input {
      margin-top: 10px;
    }
    .el-input-group__append {
      .sendcode {
        cursor: not-allowed;

        color: #999;
      }
      .sendcode1 {
        cursor: pointer;

        color: #4a93f6;
      }
    }
  }
  .el-input:first-child {
    margin-top: 0;
  }

  .el-checkbox {
    .el-checkbox__label {
      font-size: 13px !important;
      span {
        color: #4a93f6;
      }
    }
  }
}
@media (max-width: 640px) {
    .newEnLogin{
        display: block !important;
        margin-top: -56px;
        .newEnLogin-left{
            width: 100%;
        }
        .newEnLogin-right{
            position: absolute;
            width: 90vw;
            top: 20%;
            left: 5vw;
            height: auto;
            padding-top: 50px;
            border-radius: 5px;
            .botinfo{display:none;}
        }
    }
  .loginbig {
    background-size: cover;
    background-position: 100%;
    .enCenForm {
      display: none;
    }
    .enform {
      display: block;
      width: 95%;
      margin: 0 auto;
      position: absolute;
      top: 50%;
      margin-top: -250px;
      right: 50%;
      margin-right: -47.5%;
      height: 500px;
      .enform-ipt {
        margin-top: 0;
      }
    }
  }
}
::v-deep{
  @media (max-width: 640px) {
        .enform-ys{
    .el-checkbox{
      display:flex;
      align-items: center;
      .el-checkbox__label{
            display: flex !important;
    flex-wrap: wrap !important;
      }
    }
  }
  }
}
</style>